module.exports = __webpack_public_path__ + "img/payBg.e91cc649.png";